/*
 * @Date: 2022-06-29 10:41:27
 * @LastEditors: guantingting
 * @LastEditTime: 2023-07-10 16:54:34
 */
import { getUrlParam } from './common'
import wx from 'weixin-js-sdk'
export const isWeixin = /MicroMessenger/i.test(navigator.userAgent)
const u = navigator.userAgent;
export function getWxEnv() {
  return new Promise((resolve) => {
    if (!wx) resolve('wechat')
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        resolve('miniprogram')
      } else {
        resolve('wechat')
      }
    })
  })
}
export const isMiniprogram = async () =>
  isWeixin && (await getWxEnv() === 'miniprogram') //判断是否是 小程序
export const isZfb = u.toLowerCase().indexOf('aliapp') > -1 //判断是否是 支付宝
export function getZfbEnv() {
  return new Promise((resolve) => {
    if (!my) resolve('zfb')
    my.getEnv((res) => {
      if (res.miniprogram) {
        resolve('zfb_mini')
      } else {
        resolve('zfb')
      }
    })
  })
}
export const isZfbMini = async () => isZfb && (await getZfbEnv() === 'zfb_mini') //判断是否是 支付宝小程序
export const isApp = window.navigator.userAgent.indexOf('rv2go') > -1
export const isWebAndroid = isApp && (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) //判断是否是 android app webview
export const isWebIOS = isApp && (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) //判断是否是 iOS app webview
export const isWechat = async () => isWeixin && (await getWxEnv() === 'wechat') //判断是否是 微信浏览器
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //判断是否是 android终端
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是否是 iOS终端
export const isHarmony = u.indexOf('Harmony') > -1  //判断是否是 鸿蒙
export const getEnv = async () => {
  if (isWebAndroid) {
    return 'android'
  } else if (isWebIOS) {
    return 'ios'
  } else if (await isMiniprogram()) {
    return 'mini'
  } else if (await isZfbMini()) {
    return 'zfb_mini'
  } else {
    return 'm'
  }
}
// 判断浏览器函数
export const isMobile = () => {
  if (isAndroid || isIOS) {
    return true; // 移动端
  } else {
    return false; // PC端
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/judgeEnv.js